module.exports = __webpack_public_path__ + "images/doc-folder-grid-ee94f7b1c323f74eff240fb143f912fe.png";